import { type ZoomLevelName } from './types';

export const resourcePlanningComponentsRequiringPermissions = [
	'TimeOffListPopover',
];

export const DEFAULT_BOOKING_AMOUNT = {
	TIME_PER_DAY: 28800,
	TIME_TOTAL: 3600,
	PERCENT: 100,
} as const;

export const SETTINGS = {
	ZOOM_LEVEL: 'zoom_level',
	HEAT_MAP: 'heat_map',
	BOOKING_TYPE: 'booking_type',
	SHOW_PLACEHOLDERS: 'show_placeholders',
	HIDE_PROJECTS_WITHOUT_BOOKINGS: 'hide_projects_without_bookings',
} as const;

export const ACTION_SHORTCUT_OPTIONS = {
	MARK_ALL_FIXED: 'mark_all_fixed',
	MOVE_BOOKINGS: 'move_bookings',
	REMOVE_PROJECT_MEMBER: 'remove_project_member',
	NEW_BOOKING: 'new_booking',
	CLEAR_BOOKINGS: 'clear_bookings',
	ASSIGN_MEMBER: 'assign_member',
} as const;

export const CHART_ITEM_TYPE = {
	PROJECT: 'project',
	BOOKING: 'booking',
	RESOURCE: 'resource',
	BOOKING_LIST: 'booking_list',
	PLACEHOLDER: 'placeholder',
	ROLE: 'role',
	ADD_TO_PROJECT: 'add_to_project',
	ROLE_DIRECTORY: 'role_directory',
	TIME_OFF: 'time_off',
} as const;

export const CHART_ROW_TYPE = {
	OTHER: 'other',
	HEATMAP: 'heatmap',
	BOOKINGS: 'bookings',
} as const;

export const ZOOM_OPTIONS = {
	DAY: 'zoom_level_days',
	WEEK: 'zoom_level_weeks',
	MONTH: 'zoom_level_months',
} as const;

export const ZOOM_UNIT = {
	DAY: 'day',
	WEEK: 'week',
	MONTH: 'month',
	QUARTER: 'quarter',
	YEAR: 'year',
} as const;

export const ZOOM_SCALE_OPTIONS: ZoomLevelName[] = [
	ZOOM_OPTIONS.MONTH,
	ZOOM_OPTIONS.MONTH,
	ZOOM_OPTIONS.MONTH,
	ZOOM_OPTIONS.MONTH,
	ZOOM_OPTIONS.MONTH,
	ZOOM_OPTIONS.WEEK,
	ZOOM_OPTIONS.WEEK,
	ZOOM_OPTIONS.WEEK,
	ZOOM_OPTIONS.DAY,
	ZOOM_OPTIONS.DAY,
	ZOOM_OPTIONS.DAY,
];

export const HEAT_MAP_OPTIONS = {
	PERCENT: 'percent',
	BOOKED: 'booked',
	REMAINING: 'remaining',
} as const;

export const BOOKING_ALLOCATION_TYPE = {
	FIXED: 'fixed',
	TENTATIVE: 'tentative',
} as const;

export const BOOKING_TYPE_FILTER = {
	FIXED: 'fixed',
	TENTATIVE: 'tentative',
	FIXED_AND_TENTATIVE: 'fixed_and_tentative',
} as const;

export const RESOURCE_PROPERTY = 'resource_id';

export const RENDER_TYPE_SPLIT = 'split' as const;

export const MAX_ZOOM_LEVEL = ZOOM_SCALE_OPTIONS.indexOf(ZOOM_OPTIONS.MONTH);

export const MIN_ZOOM_LEVEL = ZOOM_SCALE_OPTIONS.lastIndexOf(ZOOM_OPTIONS.DAY);

export const PLACEHOLDER_BG_COLOR = '#f7f9fd';

export const WATCH_TUTORIAL_URL =
	'https://support.scoro.com/hc/en-us/articles/25995337245197';

export const UTILIZATION_FETCH_INTERVAL = 12; // months

export const UTILIZATION_RENDER_DEBOUNCE_MS = 100;

export const UTILIZATION_FETCH_USER_BATCH_SIZE = 40;

export const BOOKING_VISIBLE_PROJECT_ID = '-1' as const;

export const RESOURCE_PLANNING_CONTAINER_ID = 'resource-planning';

export const RESOURCE_PLANNING_PORTFOLIO_CONTAINER_ID =
	'resource-planning-portfolio';
